import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { CustomButton } from "components/CustomButton";
import { IndicationField } from '../IndicationField';

export function VerificationCodeStep({
  open,
  themeColor,
  handleClose,
  BasicLogin,
  userInfo,
  SendConfirmationToken,
}) {
  const defaultColor = themeColor?.titles?.highlight?.textColor
  const [timeLeft, setTimeLeft] = React.useState(120); // 2 minutos
  const [canResend, setCanResend] = React.useState(false);
  const [code, setCode] = React.useState('');

  React.useEffect(() => {
    if (!open) return; // evita executar quando o modal está fechado
    setTimeLeft(120);
    setCanResend(false);

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResend(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval); // limpa o intervalo ao fechar
  }, [open]);

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, '0');
    const s = String(seconds % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  const handleResendCode = () => {
    // Aqui você colocaria a lógica para reenviar o código
    console.log("Código reenviado");
    setTimeLeft(120);
    setCanResend(false);
    BasicLogin(userInfo?.cpf);
  };

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        backdropFilter: 'blur(2px)',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 470,
          bgcolor: '#FFFFFF',
          p: '28px 25px',
          borderRadius: '12px',
          boxShadow: '0px 8px 24px rgba(0,0,0,0.12)',
          gap: '20px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography sx={{ color: '#5D5D5D', font: 'bold 15px Roboto' }}>
            CÓDIGO
          </Typography>
          <Box
            component="span"
            className='icon-ico_cancelar'
            onClick={handleClose}
            fontSize="20px"
            color="#e43a3a"
            sx={{ cursor: 'pointer' }}
          />
        </Box>

        <Typography sx={{ color: '#5D5D5D', fontSize: '14px', lineHeight: 1.6 }}>
          Para continuar, insira o código de autenticação que <br />
          foi envia do via <b>SMS</b> para o <b>celular {userInfo?.phoneNumber2}.</b>
        </Typography>

        <Box
          gap="16px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection={"column"}
        >
          <IndicationField
            amount={4}
            width="36px"
            height="60px"
            value={code}
            onChange={(e) => setCode(e)}
          />
          <Typography align="center" sx={{ color: '#5D5D5D', fontSize: '14px' }}>
            Nova validação em  <br />
            <b style={{ color: defaultColor || '#8a8a8a' }}>{formatTime(timeLeft)}</b>
          </Typography>
          <Box display="flex" justifyContent="center" width="100%" gap={'15px'}>
            <CustomButton
              size="sm"
              Confirmar
              variant="contained"
              style={{ maxWidth: '174px' }}
              disabled={!code}
              onClick={() => {
                SendConfirmationToken(userInfo?.cpf, code);
              }}
            >
              Confirmar
            </CustomButton>
          </Box>
          <Typography
            align="center"
            sx={{
              color: !canResend ? '#8a8a8a' : (defaultColor || '#8a8a8a'),
              fontSize: '14px',
              cursor: !canResend ? 'not-allowed' : 'pointer',
            }}
            onClick={() => canResend && handleResendCode()}
          >
            Enviar novo código
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
}
